
import m from "mithril";

const Backup = {
    isLoading: false,
    error: null,

    downloadBackup: async () => {
        Backup.isLoading = true;
        Backup.error = null;
        m.redraw();

        try {
            // We use standard window.location to trigger download
            // But to handle errors better, we might want to fetch first?
            // For large files, direct navigation is better.
            // However, we can use a temporary <a> tag with target="_blank"

            // To ensure we can catch auth errors or 500s easily before streaming starts, 
            // we could do a HEAD request? Or just use fetch and blob.
            // Using fetch + blob allows us to name the file properly and check status.

            const response = await fetch('/api/backup/download');

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Download failed');
            }

            // Create blob and download
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;

            // Get filename from header if available
            const disposition = response.headers.get('Content-Disposition');
            let filename = 'backup.sql';
            if (disposition && disposition.indexOf('attachment') !== -1) {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
            }

            a.download = filename;
            document.body.appendChild(a);
            a.click();

            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);

        } catch (error) {
            console.error('Backup download error:', error);
            Backup.error = error.message;
        } finally {
            Backup.isLoading = false;
            m.redraw();
        }
    },

    view: () => {
        return m("div", { class: "p-6" }, [
            m("h1", { class: "text-2xl font-bold mb-6 text-gray-800 dark:text-gray-200" }, "Database Backup"),

            m("div", { class: "bg-white dark:bg-gray-800 rounded-lg shadow p-6 max-w-xl" }, [
                m("div", { class: "mb-6" }, [
                    m("p", { class: "text-gray-600 dark:text-gray-300" },
                        "Unduh file backup database lengkap (SQL format). File ini dapat digunakan untuk memulihkan database jika terjadi masalah."
                    ),
                    m("div", { class: "mt-4 p-4 bg-orange-50 dark:bg-orange-900/20 border-l-4 border-orange-500 text-orange-700 dark:text-orange-400 text-sm" },
                        [
                            m("p", { class: "font-semibold" }, "Perhatian User:"),
                            m("p", "Proses backup mungkin membutuhkan waktu beberapa detik tergantung ukuran database. Harap tunggu hingga download dimulai.")
                        ]
                    )
                ]),

                Backup.error && m("div", { class: "mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded" }, [
                    m("p", `Error: ${Backup.error}`)
                ]),

                m("button", {
                    class: `flex items-center justify-center w-full px-4 py-3 bg-orange-600 hover:bg-orange-700 text-white font-medium rounded-lg transition duration-150 ease-in-out ${Backup.isLoading ? 'opacity-70 cursor-not-allowed' : ''}`,
                    onclick: Backup.downloadBackup,
                    disabled: Backup.isLoading
                }, [
                    Backup.isLoading
                        ? [m("i", { class: "ri-loader-4-line animate-spin mr-2" }), "Memproses..."]
                        : [m("i", { class: "ri-download-cloud-2-line mr-2" }), "Download Backup (.sql)"]
                ])
            ])
        ]);
    }
};

export default Backup;
